export default {
  title: 'Uusi variantti',
  fields: {
    product: {
      label: 'Tuote',
    },
    name: {
      label: 'Nimi',
      placeholder: 'Suuri',
    },
    price: {
      label: 'Lisähinta',
    },
  },
  buttons: {
    save: 'Tallenna',
    close: 'Sulje',
  },
  toasts: {
    variant_got_created: 'Variantti luotu',
    variant_got_updated: 'Variantti päivitetty',
  },
};
